import React from "react";
import {
  VegaBox,
  VegaFlex,
  VegaIcon,
  VegaFont,
} from "@heartlandone/vega-react";
import "./module.css";

const ScoreItemConfigs = [
  {
    key: "poor",
    score: 1,
    label: "Poor",
    icon: "far fa-face-tired",
  },
  {
    key: "noGood",
    score: 2,
    label: "Not Good",
    icon: "far fa-face-unamused",
  },
  {
    key: "average",
    score: 3,
    label: "Average",
    icon: "far fa-face-thinking",
  },
  {
    key: "good",
    score: 4,
    label: "Good",
    icon: "far fa-face-smile-wink",
  },
  {
    key: "excellent",
    score: 5,
    label: "Excellent",
    icon: "far fa-face-laugh-beam",
  },
];

const ScoreItem = ({ itemConfig, onItemClick, disabled, isActive }) => {
  const feedbackClassNames = (config) => {
    const classNames = ["feedback-item"];
    classNames.push(`feedback-key-${config.key}`);
    isActive && classNames.push(`feedback-active`);
    disabled && classNames.push(`feedback-disabled`);
    return classNames.join(" ");
  };
  return (
    <VegaBox
      className={feedbackClassNames(itemConfig)}
      onClick={() => onItemClick(itemConfig.score)}
    >
      <VegaFlex
        className="container"
        corners="rounded-8"
        padding={"size-16"}
        alignItems="center"
        justifyContent="center"
      >
        <VegaFlex
          direction="col"
          alignItems="center"
          justifyContent="center"
          gap="size-8"
        >
          <VegaIcon size="size-24" icon={itemConfig.icon} />
          <VegaFont variant="font-field-label-sm">{itemConfig.label}</VegaFont>
        </VegaFlex>
      </VegaFlex>
    </VegaBox>
  );
};

const ScoreItems = ({ currentScore, onItemClick, disabled }) => {
  return (
    <VegaFlex
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      gap="size-16"
    >
      {ScoreItemConfigs.map((config) => (
        <ScoreItem
          itemConfig={config}
          onItemClick={onItemClick}
          disabled={disabled}
          isActive={currentScore === config.score}
        ></ScoreItem>
      ))}
    </VegaFlex>
  );
};

export default ScoreItems;
